// Activity entries a membership gives (benefit 'activityentries': entrycount per entrywindow) and how
// many of this window's are used - shown on the customer's own profile, like the old series cards.
//
// The balance comes from ui-get 'getMembershipEntries' (kumpula/ACTIVITY_ENTRIES_BACKEND_CHANGES.md):
// [{ id, membershipid, activityentries: { entrycount, entrywindow, used, remaining } }]. Nothing stores a
// counter; the backend counts the window's sign-ups priced with an entry.

const WINDOW_KEYS = {
  day: 'activity_entries_window_day',
  week: 'activity_entries_window_week',
  month: 'activity_entries_window_month',
  year: 'activity_entries_window_year',
}

// The balance of a membership product. Balances are per product, so every period of a renewed
// membership (groupMemberships) shows the same one.
export const balanceFor = (entries, membershipid) => {
  if (!Array.isArray(entries) || !membershipid) return null
  const row = entries.find((e) => e && e.membershipid === membershipid && e.activityentries)
  const b = row ? row.activityentries : null
  if (!b || !(Number(b.entrycount) > 0) || !WINDOW_KEYS[b.entrywindow]) return null
  return b
}

// 'Aktiviteettikerrat tässä kuussa: 3/8 käytetty, 5 jäljellä'
export const entriesText = (balance, t) => {
  if (!balance) return ''
  const count = Number(balance.entrycount) || 0
  const used = Math.max(0, Number(balance.used) || 0)
  const remaining = balance.remaining !== undefined ? Math.max(0, Number(balance.remaining) || 0) : Math.max(0, count - used)
  return t('activity_entries_line')
    .replace('{WINDOW}', t(WINDOW_KEYS[balance.entrywindow]))
    .replace('{USED}', used)
    .replace('{COUNT}', count)
    .replace('{LEFT}', remaining)
}
